import CardDiv from "modules/common/card-div/CardDiv";
import React, { useEffect, useState } from "react";
import useConversionStore from "./store";
import SessionGraph from "./SessionGraph";
import ConversionDashboard from "./ConversionDashboard";
import moment from "moment";
import DatePicker from "react-datepicker";
import AovDashboard from "./AovDashboard";

function ReportDashboard() {
  const {
    sessionData,
    sessionLoading,
    getSessionData,
    aovData,
    aovLoading,
    getAovData,
    converionData,
    conversionLoading,
    getConversionData,
  } = useConversionStore();

  const [submitFlag, setSubmitFlag] = useState(0);
  const currentDate = new Date();
  const [currentHour, setCurrentHour] = useState(null);
  const [compStartDate, setCompStartDate] = useState(
    currentDate.getTime() - 24 * 60 * 60 * 1000
  );
  const [endLastDate, setEndDate] = useState(currentDate);
  const [prevLastDate, setPrevLastDate] = useState(currentDate);

  useEffect(() => {
    const now = moment();
    const hour = now.format("H");
    setCurrentHour(hour);
  }, []);

  useEffect(() => {
    const startDate = moment(endLastDate).startOf("day").toISOString();
    const endDate = moment(endLastDate).endOf("day").toISOString();
    const compareStartDate = moment(compStartDate).startOf("days").toISOString();
    const compareEndDate = moment(compStartDate).endOf("day").toISOString();
    getAovData(startDate, endDate, compareStartDate, compareEndDate);
    getSessionData(startDate, endDate, compareStartDate, compareEndDate);
    getConversionData(startDate, endDate, compareStartDate, compareEndDate);
  }, [submitFlag]);

  const extractSessionData = (sessionData, target, allFlag = false) => {
    let sessionMap = {
      new_customer: [],
      repeat_customer: [],
      totalSum: [],
    };
    let newSum = 0;
    let repeatSum = 0;
    let totalCxSum = 0;
    for (let day in sessionData[target]) {
      if (
        Number(currentHour) + 1 <= Number(day) && prevLastDate === endLastDate && !allFlag
      ) {
        break;
      }
      for (let customer in sessionMap) {
        if (!(Number(currentHour) + 1 <= Number(day) && prevLastDate === endLastDate)) {
          newSum += Number(sessionData[target][day]["new_customer"]);
          repeatSum += Number(sessionData[target][day]["repeat_customer"]);
          totalCxSum +=Number(sessionData[target][day]["new_customer"]) + Number(sessionData[target][day]["repeat_customer"]);
        }
        if (customer === "totalSum") {
          sessionMap[customer].push( Number(sessionData[target][day]["new_customer"]) + Number(sessionData[target][day]["repeat_customer"]));
        } else {
          sessionMap[customer].push(sessionData[target][day][customer]);
        }
      }
    }
    return { ...sessionMap, newSum, repeatSum, totalCxSum };
  };
  const extractFormFillData = (converionData, target, allFlag = false) => {
    const conversionMap = {
      totalFormFill: [],
      totalConversion: [],
      totalAbandonedCarts: [],
    };
    let totalFormSum = 0;
    let totalConversionSum = 0;
    let totalAbandonSum = 0;
    for (let day in converionData[target]) {
      if (Number(currentHour) + 1 <= Number(day) &&prevLastDate === endLastDate && !allFlag) {
        break;
      }
      for (let customer in conversionMap) {
        conversionMap[customer].push(converionData[target][day][customer]);
        if (!(Number(currentHour) + 1 <= Number(day) && prevLastDate === endLastDate)) {
          totalFormSum += Number(converionData[target][day]["totalFormFill"]);
          totalConversionSum += Number(converionData[target][day]["totalConversion"]);
          totalAbandonSum += Number(converionData[target][day]["totalAbandonedCarts"]);
        }
      }
    }
    return {
      ...conversionMap,
      totalFormSum,
      totalConversionSum,
      totalAbandonSum,
    };
  };

  const extractAovData = (aovData, target, allFlag = false) => {
    const aovMap = {
      totalOrderValue: [],
      totalOrderCount: [],
      avgOrderValue: [],
      maleNewAov: [],
      maleNewTotalValue: [],
      maleNewOrderCount: [],
      femaleNewAov: [],
      femaleNewTotalValue: [],
      femaleNewOrderCount: [],
      maleRepeatAov: [],
      maleRepeatTotalValue: [],
      maleRepeatOrderCount: [],
      femaleRepeatAov: [],
      femaleRepeatTotalValue: [],
      femaleRepeatOrderCount: [],
      maleTotalValue: [],
      femaleTotalValue: [],
      maleOrderCount: [],
      femaleOrderCount: [],
      maleAov: [],
      femaleAov: [],
      NewTotalValue: [],
      NewOrderCount: [],
      NewAov: [],
      RepeatTotalValue: [],
      RepeatOrderCount: [],
      RepeatAov: [],
    };

    for (let day in aovData[target]) {
      if ( Number(currentHour) + 1 <= Number(day) && prevLastDate === endLastDate && !allFlag) { 
        break;
      }
      aovMap.maleNewAov.push(aovData[target][day]["male"]["newOrderAvg"]);
      aovMap.maleNewTotalValue.push(aovData[target][day]["male"]["newValue"]);
      aovMap.maleNewOrderCount.push(aovData[target][day]["male"]["newCount"]);
      aovMap.maleRepeatAov.push(aovData[target][day]["male"]["repeatOrderAvg"]);
      aovMap.maleRepeatTotalValue.push(aovData[target][day]["male"]["repeatValue"]);
      aovMap.maleRepeatOrderCount.push(aovData[target][day]["male"]["repeatCount"]);
      //this is for female
      aovMap.femaleNewAov.push(aovData[target][day]["female"]["newOrderAvg"]);
      aovMap.femaleNewTotalValue.push(aovData[target][day]["female"]["newValue"]);
      aovMap.femaleNewOrderCount.push(aovData[target][day]["female"]["newCount"]);
      aovMap.femaleRepeatAov.push(aovData[target][day]["female"]["repeatOrderAvg"]);
      aovMap.femaleRepeatTotalValue.push(aovData[target][day]["female"]["repeatValue"]);
      aovMap.femaleRepeatOrderCount.push(aovData[target][day]["female"]["repeatCount"]);
      aovMap.totalOrderValue.push(aovData[target][day]["totalOrderValue"]);
      aovMap.totalOrderCount.push(aovData[target][day]["totalOrderCount"]);
      aovMap.avgOrderValue.push(aovData[target][day]["avgOrderValue"]);
      // Total data update
      aovMap.maleTotalValue.push(aovData[target][day]["male"]["totalValue"]);
      aovMap.femaleTotalValue.push(aovData[target][day]["female"]["totalValue"]);
      aovMap.maleOrderCount.push(aovData[target][day]["male"]["totalCount"]);
      aovMap.femaleOrderCount.push(aovData[target][day]["female"]["totalCount"]);
      aovMap.maleAov.push(aovData[target][day]["male"]["avgTotalValue"]);
      aovMap.femaleAov.push(aovData[target][day]["female"]["avgTotalValue"]);
      //New Repeat Data
      aovMap.NewTotalValue.push(Number(aovData[target][day]["male"]["newValue"]) + Number(aovData[target][day]["female"]["newValue"]));
      aovMap.NewOrderCount.push(Number(aovData[target][day]["male"]["newCount"]) + Number(aovData[target][day]["female"]["newCount"]));
      aovMap.NewAov.push(Number(aovData[target][day]["male"]["newOrderAvg"]) + Number(aovData[target][day]["female"]["newOrderAvg"]));
      aovMap.RepeatTotalValue.push(Number(aovData[target][day]["male"]["repeatValue"]) + Number(aovData[target][day]["female"]["repeatValue"]));
      aovMap.RepeatOrderCount.push(Number(aovData[target][day]["male"]["repeatCount"]) + Number(aovData[target][day]["female"]["repeatCount"]));
      aovMap.RepeatAov.push(Number(aovData[target][day]["male"]["repeatOrderAvg"]) + Number(aovData[target][day]["female"]["repeatOrderAvg"]));
    }
    return aovMap;
  };

  //Session data report
  const todaySessionData = extractSessionData(sessionData, "currentData");
  const yestSessionData = extractSessionData(sessionData, "previousData", true);
  //FormFillData
  const todayFormData = extractFormFillData(converionData, "currentData");
  const yestFormData = extractFormFillData(converionData, "previousData", true);
  //Extract Aov Data
  const todayAovData = extractAovData(aovData, "currentData");
  const yestAovData = extractAovData(aovData, "previousData", true);

  const handleSubmit = () => {
    setSubmitFlag(submitFlag + 1);
  };

  const handleClear = () => {
    const currentDate = new Date();
    setCompStartDate(currentDate.getTime() - 24 * 60 * 60 * 1000);
    setPrevLastDate(currentDate);
    setEndDate(currentDate);
    setSubmitFlag(submitFlag + 1);
  };

  return (
    <div className="">
      <CardDiv
        title={
          <div className="d-flex justify-content-between my-n2 align-items-center">
            <div className="fw-bold ">Customer Report Data </div>{" "}
            <div>
              <div className="d-flex gap-2">
                <DatePicker
                  selected={compStartDate}
                  onChange={(date) => setCompStartDate(date)}
                  formatWeekDay={(day) => day.slice(0, 3)}
                  className="form-control"
                  placeholderText="Select previous Date"
                  maxDate={endLastDate}
                />
                <DatePicker
                  selected={endLastDate}
                  onChange={(date) => setEndDate(date)}
                  formatWeekDay={(day) => day.slice(0, 3)}
                  className="form-control"
                  placeholderText="Select current Date"
                  maxDate={new Date()}
                  minDate={compStartDate}
                />
                <button className="btn btn-primary" onClick={handleSubmit}>
                  Submit
                </button>
                <button className="btn btn-primary" onClick={handleClear}>
                  Clear
                </button>
              </div>
            </div>{" "}
          </div>
        }
        component={
          <div className="d-flex flex-column gap-2">
            <div className="w-full d-flex gap-2">
              <div className="w-50 mt-n4 mb-4 p-2 card">
                <div className="fs-2 fw-bold  mb-2">Session Graph</div>
                <SessionGraph
                  loading={sessionLoading}
                  todaySessionData={todaySessionData}
                  yestSessionData={yestSessionData}
                />
              </div>
              <div className="p-2 mt-n4 mb-4 card w-50">
                <ConversionDashboard
                  loading={conversionLoading}
                  todayFormData={todayFormData}
                  yestFormData={yestFormData}
                />
              </div>
            </div>
            <div className="card p-2 mt-n4">
              <div className="my-1 mb-2 fw-bold fs-1">AOV Dashboard</div>
              <AovDashboard
                loading={aovLoading}
                todayFormData={todayAovData}
                yestFormData={yestAovData}
              />
            </div>
          </div>
        }
      />
    </div>
  );
}

export default ReportDashboard;
